export default "__VITE_ASSET__CdPwB2Fl__"